import React, { Fragment } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { createSelector } from "reselect";
import { connect } from "react-redux";
import { ScrollToTop, history, Notifier, Role } from './helpers';
import { GuestRoute, RoleRoute } from './route';
import { userActions } from './common/redux/actions';
import { globalService as gs } from './common/services';
import { NotFound } from './views/components/Exceptions';
import { Register, Login, ForgotPassword, ResetPassword, EmailVerify, BecomeTutor } from './views/components/Auth';
import { Home, About, ContactUs, ComingSoon, Faqs, ContentPage } from './views/components/Content';
import { TutorSearch, TutorSearchView } from './views/components/Search';
import { UserDashboard, UserChangePassword, UserProfileUpdate, UserBookingList, UserBookingView, UserCompletedSessionsList, UserCompletedSessionsView, UserCancelledSessionsList, UserCancelledSessionsView, UserFavorites, UserPaymentMethod, UserTransaction, UserProfilePhoto, Notifications, UserDeactivateAccount, UserDisputedSessionsList } from './views/components/User';
import { TutorDashboard, TutorChangePassword, TutorBookingList, TutorBookingView, TutorCompletedSessionsList, TutorCompletedSessionsView, TutorCancelledSessionsList, TutorCancelledSessionsView, TutorPaymentMethod, TutorTransaction, TutorProfilePhoto, TutorUpdateProfile, Background, SetPrices, SetAvailability, PaymentDetails, TutorMemberShip, CustomUnavailability, TutorDeactivateAccount, TutorDisputedSessionsList } from './views/components/Tutor';
import Messanger from './views/components/Messanger';
import { withCookies } from 'react-cookie';
import CookiesName from './CookiesName';
import * as moment from 'moment-timezone';
moment.tz.setDefault('America/New_York');


class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			
		};
	}

	componentDidMount() {
		const { dispatch, authentication } = this.props;
		//dispatch(defaultActions.pages("GET", {moduleId: 'page'}))
        if(authentication.loggedIn) {
			const { user } = authentication.authentication
			let user_id = user.id;
			gs.db.ref(`User/${user_id}/is_notified`)
			.on("value", (snap) => {
				//console.log('snapsnapsnapsnap', snap);
				dispatch(userActions.profile("GET", null, 'load_profile'));
			});
            //dispatch(userActions.profile("GET", null, 'load_profile'));
        }
	}

	render() {

		return (<Fragment>
			<Notifier />
			<CookiesName />
			<Router history={history}>
				<ScrollToTop>
					<Switch>
						<Route exact path="/" component={Home} />
						<Route path="/home" component={Home}/>
						
						{/* Auth pages routs */}
						<Route path="/register" component={Register} />
						<Route path="/become-tutor" component={BecomeTutor} />
						<Route path="/login" component={Login} />
						<Route path="/forgot-password" component={ForgotPassword} />
						<Route path="/reset-password" component={ResetPassword} />
						<Route path="/email-verification" component={EmailVerify} />

						{/* User Pages */}
						<GuestRoute path="/search-tutors" component={TutorSearch} />
						<GuestRoute path="/tutor/view/:id" component={TutorSearchView} />

						{/* Parent Pages */}
						<RoleRoute exact path="/user/dashboard" component={UserDashboard} roles={[Role.User]} />
						<RoleRoute exact path="/user/change-password" component={UserChangePassword} roles={[Role.User]} />
						<RoleRoute exact path="/user/update-profile" component={UserProfileUpdate} roles={[Role.User]} />
						<RoleRoute exact path="/user/deactivate-account" component={UserDeactivateAccount} roles={[Role.User]} />
						<RoleRoute exact path="/user/bookings" component={UserBookingList} roles={[Role.User]} />
						<RoleRoute exact path="/user/booking/:id" component={UserBookingView} roles={[Role.User]} />
						<RoleRoute exact path="/user/completed-sessions" component={UserCompletedSessionsList} roles={[Role.User]} />
						<RoleRoute exact path="/user/completed-session/:id" component={UserCompletedSessionsView} roles={[Role.User]} />
						<RoleRoute exact path="/user/cancelled-sessions" component={UserCancelledSessionsList} roles={[Role.User]} />
						<RoleRoute exact path="/user/disputed-sessions" component={UserDisputedSessionsList} roles={[Role.User]} />
						<RoleRoute exact path="/user/cancelled-session/:id" component={UserCancelledSessionsView} roles={[Role.User]} />
						<RoleRoute exact path="/user/favorites" component={UserFavorites} roles={[Role.User]} />
						<RoleRoute exact path="/user/payment-method" component={UserPaymentMethod} roles={[Role.User]} />
						<RoleRoute exact path="/user/transaction" component={UserTransaction} roles={[Role.User]} />
						<RoleRoute exact path="/user/profile-photo" component={UserProfilePhoto} roles={[Role.User]} />

						<RoleRoute exact path="/notifications" component={Notifications} roles={[Role.User, Role.Tutor]} />
						<RoleRoute exact path="/messages" component={Messanger} roles={[Role.User, Role.Tutor]} />

						{/* Tutor Pages */}
						<RoleRoute exact path="/tutor/dashboard" component={TutorDashboard} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/change-password" component={TutorChangePassword} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/profile" component={TutorUpdateProfile} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/deactivate-account" component={TutorDeactivateAccount} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/background" component={Background} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/set-prices" component={SetPrices} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/set-availability" component={SetAvailability} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/custom-unavailability" component={CustomUnavailability} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/payment-details" component={PaymentDetails} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/bookings" component={TutorBookingList} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/booking/:id" component={TutorBookingView} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/completed-sessions" component={TutorCompletedSessionsList} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/disputed-sessions" component={TutorDisputedSessionsList} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/completed-session/:id" component={TutorCompletedSessionsView} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/cancelled-sessions" component={TutorCancelledSessionsList} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/cancelled-session/:id" component={TutorCancelledSessionsView} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/payment-method" component={TutorPaymentMethod} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/transaction" component={TutorTransaction} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/profile-photo" component={TutorProfilePhoto} roles={[Role.Tutor]} />
						<RoleRoute exact path="/tutor/membership" component={TutorMemberShip} roles={[Role.Tutor]} />

						{/* Content pages routs */}
						<Route path="/about-us" component={About} />
						<Route path="/contact-us" component={ContactUs} />
						<Route path="/faqs" component={Faqs} />
						<Route path="/:slug" component={ContentPage} />
						<Route path="/comming/:slug" component={ComingSoon} />

						{/* App pages routs */ }
						
						<Route path="*" component={NotFound} />
					</Switch>
				</ScrollToTop>
			</Router>
		</Fragment>);
	}
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    authenticationSelector,
    (authentication) => ({
        authentication
    })
);
export default withCookies(connect(mapStateToProps)(App));
